/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ContactEventEntity
 */
export interface ContactEventEntity {
    /**
     * 
     * @type {number}
     * @memberof ContactEventEntity
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactEventEntity
     */
    eventId?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactEventEntity
     */
    eventName?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactEventEntity
     */
    eventDisplayName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContactEventEntity
     */
    eventIsHidden?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContactEventEntity
     */
    contactId?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactEventEntity
     */
    extractionId?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactEventEntity
     */
    utteranceId?: number;
    /**
     * 
     * @type {Date}
     * @memberof ContactEventEntity
     */
    dateCreated?: Date;
}

/**
 * Check if a given object implements the ContactEventEntity interface.
 */
export function instanceOfContactEventEntity(value: object): boolean {
    return true;
}

export function ContactEventEntityFromJSON(json: any): ContactEventEntity {
    return ContactEventEntityFromJSONTyped(json, false);
}

export function ContactEventEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactEventEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'eventId': json['eventId'] == null ? undefined : json['eventId'],
        'eventName': json['eventName'] == null ? undefined : json['eventName'],
        'eventDisplayName': json['eventDisplayName'] == null ? undefined : json['eventDisplayName'],
        'eventIsHidden': json['eventIsHidden'] == null ? undefined : json['eventIsHidden'],
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'extractionId': json['extractionId'] == null ? undefined : json['extractionId'],
        'utteranceId': json['utteranceId'] == null ? undefined : json['utteranceId'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
    };
}

export function ContactEventEntityToJSON(value?: ContactEventEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'eventId': value['eventId'],
        'eventName': value['eventName'],
        'eventDisplayName': value['eventDisplayName'],
        'eventIsHidden': value['eventIsHidden'],
        'contactId': value['contactId'],
        'extractionId': value['extractionId'],
        'utteranceId': value['utteranceId'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
    };
}

